import {db, fb} from '../../firebase/index';
import {initialState} from "../Store/initialState";

export const fetchQuestions = () => {
    return async (dispatch, getState) => {
        let lastVisible = getState().questions.lastVisible;
        const blockUsers = getState().user.block_users;
        const blockUsersList = Object.keys(blockUsers).filter(index => blockUsers[index] === true);
        const query = db.collection('questions').orderBy('created_at', 'desc').limit(10).startAfter(lastVisible);

        query.onSnapshot((snapshots) => {
            let currentList = getState().questions.list,
                hasMoreLoaded = getState().questions.hasMoreLoaded,
                list = [];

            snapshots.docChanges().forEach(change => {
                // Push added question to list
                if (change.type === 'added') {
                    lastVisible = change.doc.data().created_at;
                    const creatorId = change.doc.data().creator_id;
                    // Do not add questions which the blocked users posted
                    if (!blockUsersList.includes(creatorId)) {
                        list.push(change.doc.data());
                    }
                    // Stop fetching questions over 100 or if no more questions remains in the database.
                    hasMoreLoaded = (snapshots.docs.length === 10);
                } else if (change.type === 'modified') {
                    // Rewrite the modified question in the current question list
                    const index = currentList.findIndex(value => { return value.id === change.doc.id });
                    currentList[index] = change.doc.data()
                } else if (change.type === 'removed') {
                    // Remove the removed question from the current question list
                    const index = currentList.findIndex(value => { return value.id === change.doc.id });
                    currentList[index] = change.doc.data()
                }
            });

            // Merge the current question list with the new one
            const newList = currentList.concat(list);
            dispatch(updateQuestionList(newList, lastVisible, hasMoreLoaded))
        }, (error) => {
            console.error(error)
        })
    }
};

// Define Action Creators
export const UPDATE_QUESTION_LIST = "UPDATE_QUESTION_LIST";
export const updateQuestionList = (newList, lastVisible, hasMoreLoaded) => {
    return {
        type: "UPDATE_QUESTION_LIST",
        payload: {
            list: newList,
            lastVisible: lastVisible,
            hasMoreLoaded: hasMoreLoaded
        }
    }
};

/**
 * Select answer and add a value into question data
 * @param questionId {string}
 * @param type {string} The value are A || B || ""
 * @return {Function}
 */
export const selectAnswer = (questionId, type) => {
    return (dispatch, getState) => {
        const answererId = getState().user.userId;
        const path = `result.${answererId}`;
        if (type !== "") {
            return db.collection('questions').doc(questionId).update({[path]: type})
        } else {
            return db.collection('questions').doc(questionId).update({[path]: fb.firestore.FieldValue.delete()})
        }
    }
};

export const resetQuestionsList = () => {
    return {type: "UPDATE_QUESTION_LIST", payload: initialState.questions}
}
